import { render } from "./RectangleItem.vue?vue&type=template&id=40c2e08c&scoped=true&ts=true"
import script from "./RectangleItem.vue?vue&type=script&lang=ts"
export * from "./RectangleItem.vue?vue&type=script&lang=ts"

import "./RectangleItem.vue?vue&type=style&index=0&id=40c2e08c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c2e08c"]])

export default __exports__